var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, Fragment } from 'react';
import { ButtonTheme, Density } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, eventListener, expression, object, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableDeleteEvent, DeleteEvent, EditEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { createAbort, getSlot, isFunction } from '@philips-internal/oswald-ui-utils';
import { Action } from '../action/action.js';
import { Form } from '../form/form.js';
import DetailAPI from './detail-api.js';
import { DetailSlot, DetailStatus } from './detail-constants.js';
const ViewActionsContainer = {
    name: DetailSlot.VIEW_ACTIONS,
};
const EditActionsContainer = {
    name: DetailSlot.EDIT_ACTIONS,
};
let Detail = class Detail extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            state: this.props.initialState,
        };
        this.formRef = (element) => {
            if (element) {
                this.setState({ formRef: element });
            }
        };
        this.onDeleteClick = () => {
            const { onBeforeDelete, onDelete } = this.props;
            const abort = createAbort();
            if (isFunction(onBeforeDelete)) {
                onBeforeDelete(new AbortableDeleteEvent({ abort }));
            }
            void abort.promise.then((aborted) => {
                if (aborted) {
                    return;
                }
                if (isFunction(onDelete)) {
                    onDelete(new DeleteEvent());
                }
            });
        };
        this.onEditClick = () => {
            const { onEdit } = this.props;
            if (isFunction(onEdit)) {
                onEdit(new EditEvent());
            }
            this.setState({ state: DetailStatus.EDIT });
        };
        this.onCancelClick = (event) => {
            const { onCancel } = this.props;
            if (isFunction(onCancel)) {
                onCancel(event);
            }
            this.setState({ state: DetailStatus.VIEW });
        };
        this.onSubmitClick = (event) => {
            const { onSubmit } = this.props;
            if (isFunction(onSubmit)) {
                onSubmit(event);
            }
            this.setState({ state: DetailStatus.VIEW });
        };
        this.renderForm = () => {
            const { children, data, uuid } = this.props;
            const { state } = this.state;
            const formChildren = getSlot(children, DetailSlot.FORM);
            return (React.createElement(Form, { customSlot: DetailSlot.FORM, data: data, editing: state === DetailStatus.EDIT, locked: true, onCancel: this.onCancelClick, onSubmit: this.onSubmitClick, ref: this.formRef, showHeader: false, uuid: uuid }, formChildren));
        };
        this.renderEditActions = () => {
            const { children } = this.props;
            const editActions = getSlot(children, DetailSlot.EDIT_ACTIONS);
            return (React.createElement(Fragment, null, editActions));
        };
        this.renderViewActions = () => {
            const { canDelete, canEdit, children, uuid } = this.props;
            const viewActionsChildren = getSlot(children, DetailSlot.VIEW_ACTIONS);
            return (React.createElement(Fragment, null,
                canDelete ? (React.createElement(Action, { buttonTheme: ButtonTheme.SECONDARY, onClick: () => this.onDeleteClick(), text: "tws.detail.delete", uuid: `detail-delete-action-${uuid}` })) : null,
                canEdit ? (React.createElement(Action, { buttonTheme: ButtonTheme.PRIMARY, onClick: () => this.onEditClick(), text: "tws.detail.edit", uuid: `detail-edit-action-${uuid}` })) : null,
                viewActionsChildren));
        };
        this.actionsFn = {
            [DetailStatus.EDIT]: this.renderEditActions,
            [DetailStatus.VIEW]: this.renderViewActions,
        };
    }
    renderActions() {
        const { state } = this.state;
        return this.actionsFn[state]();
    }
    render() {
        const { uuid } = this.props;
        return (React.createElement("div", { className: "c-list-detail" },
            this.renderForm(),
            this.renderActions(),
            React.createElement(Container, { "data-area-name": DetailSlot.VIEW_ACTIONS, slot: ViewActionsContainer.name, uuid: uuid }),
            React.createElement(Container, { "data-area-name": DetailSlot.EDIT_ACTIONS, slot: EditActionsContainer.name, uuid: uuid })));
    }
};
Detail.propTypes = {
    cancelExpression: expression,
    canDelete: bool,
    canEdit: bool,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    data: object.notEnumerable(),
    deleteExpression: expression,
    density: oneOf(Object.values(Density)),
    editExpression: expression,
    initialState: oneOf(Object.values(DetailStatus)),
    keyField: string,
    loading: bool,
    onBeforeCancel: eventListener,
    onBeforeDelete: eventListener,
    onBeforeSubmit: eventListener,
    onCancel: eventListener,
    onChange: eventListener,
    onDelete: eventListener,
    onEdit: eventListener,
    onSubmit: eventListener,
    onValidate: eventListener,
    saveExpression: expression,
    uuid: string,
};
Detail.defaultProps = {
    cancelExpression: 'tws.detail.cancel',
    canDelete: true,
    canEdit: true,
    deleteExpression: 'tws.detail.delete',
    density: Density.REGULAR,
    editExpression: 'tws.detail.edit',
    initialState: DetailStatus.EDIT,
    loading: false,
    saveExpression: 'tws.detail.save',
};
Detail = __decorate([
    AwesomeComponent({ api: DetailAPI, containers: [ViewActionsContainer, EditActionsContainer], type: ComponentType.AGGREGATOR })
], Detail);
export default Detail;
//# sourceMappingURL=detail.js.map